export default "__VITE_ASSET__CQNLz7zb__"